module.exports = "/_next/static/images/dc7464fa0eca410389f71708439ae2cf-man-holding-device-2@0.75x.jpg";